import { render, staticRenderFns } from "./PoliciesListUserHasNotLoggedIn.vue?vue&type=template&id=1a722c93&"
import script from "./PoliciesListUserHasNotLoggedIn.vue?vue&type=script&lang=js&"
export * from "./PoliciesListUserHasNotLoggedIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports